import React from 'react';
import PropTypes from 'prop-types';

import DateRangePicker from 'components/DateRangePicker';
import PaymentFilter from 'components/PaymentFilter';
import ExportModal from 'components/ExportModal';

const TableTopFilters = ({
  onApplyFilter,
  onApplyDate,
  range,
  onConfirmExport,
  exportHeader,
  isExportDisabled,
  ...rest
}) => {
  return (
    <div className="grid grid-flow-row md:grid-flow-col gap-3 justify-end mb-3">
      {onApplyFilter && <PaymentFilter onSubmit={onApplyFilter} {...rest} />}

      <div className="grid grid-flow-col gap-3 items-center self-end">
        {onApplyDate && <DateRangePicker onApply={onApplyDate} range={range} />}
        {onConfirmExport && (
          <ExportModal
            title={exportHeader}
            onConfirm={onConfirmExport}
            isDisabled={isExportDisabled}
          />
        )}
      </div>
    </div>
  );
};

TableTopFilters.propTypes = {
  onApplyFilter: PropTypes.func,
  onApplyDate: PropTypes.func,
  range: PropTypes.shape({}),
  onConfirmExport: PropTypes.func,
  exportHeader: PropTypes.string,
  isExportDisabled: PropTypes.bool,
};
export default TableTopFilters;
